const table = [
    {
        prop: 'Agente',
        label: 'Agente',
        minWidth: 200
    },
    {
        prop: 'HoraI',
        label: 'Hora Inicial',
        minWidth: 200
    },
    {
        prop: 'HoraF',
        label: 'Hora Final',
        minWidth: 200
    },
    {
        prop: 'DuracionF',
        label: 'Duración',
        minWidth: 150
    },
    {
        prop: 'Tiempo_Espera',
        label: 'Tiempo de Espera',
        minWidth: 150
    },
    {
        prop: 'umbral',
        label: 'Umbral',
        minWidth: 130
    },
    {
        prop: 'cola',
        label: 'Cola',
        minWidth: 150
    },
    {
        prop: 'tipo',
        label: 'Tipo',
        minWidth: 120
    },
    {
        prop: 'telefono',
        label: 'Telefono',
        minWidth: 200
    },
    {
        prop: 'estado',
        label: 'Estado',
        minWidth: 200
    },
]

export default table
